import React from 'react';
import { FaCheck } from 'react-icons/fa';
import {
  StepIndicatorContainer,
  StepDot,
  StepLine,
} from '../../styles';

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep, totalSteps }) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  return (
    <StepIndicatorContainer>
      {steps.map((step, index) => (
        <React.Fragment key={step}>
          <StepDot
            active={step === currentStep}
            completed={step < currentStep}
          >
            {step < currentStep ? (
              <FaCheck size={14} />
            ) : (
              step
            )}
          </StepDot>
          {index < steps.length - 1 && (
            <StepLine completed={step < currentStep} />
          )}
        </React.Fragment>
      ))}
    </StepIndicatorContainer>
  );
};

export default StepIndicator;
